var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" edit message "),_c('v-text-field',{model:{value:(_vm.localValue.message),callback:function ($$v) {_vm.$set(_vm.localValue, "message", $$v)},expression:"localValue.message"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }